var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading || !_vm.isEdit || !_vm.empty(_vm.pageInfo))?_c('div',[_c('a-card',{staticClass:"style1 pages w-100",class:[_vm.isDesktop ? 'desktop' : 'mobile']},[_c('a-form',{attrs:{"form":_vm.form,"label-col":_vm.isDesktop ? { span: 4 } : {},"wrapper-col":_vm.isDesktop ? { span: 20 } : {},"layout":_vm.isDesktop ? 'horizontal' : 'vertical'},on:{"submit":_vm.handleSubmit}},[_c('a-form-item',{attrs:{"label":"Title"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'title',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input title!',
                },
              ],
            },
          ]),expression:"[\n            'title',\n            {\n              rules: [\n                {\n                  required: true,\n                  message: 'Please input title!',\n                },\n              ],\n            },\n          ]"}],on:{"change":_vm.onGenerateSlug}})],1),_c('a-form-item',{attrs:{"label":"Slug"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'slug',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input pages slug!',
                },
              ],
            },
          ]),expression:"[\n            'slug',\n            {\n              rules: [\n                {\n                  required: true,\n                  message: 'Please input pages slug!',\n                },\n              ],\n            },\n          ]"}]})],1),_c('a-form-item',{attrs:{"label":"User Icon"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'icon_img',
            {
              rules: [
                {
                  required: true,
                  message: 'Please add Icon URL!',
                },
              ],
            },
          ]),expression:"[\n            'icon_img',\n            {\n              rules: [\n                {\n                  required: true,\n                  message: 'Please add Icon URL!',\n                },\n              ],\n            },\n          ]"}]})],1),_c('a-form-item',{attrs:{"label":"Download Video URL"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'download_video',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input download video URL!',
                },
              ],
            },
          ]),expression:"[\n            'download_video',\n            {\n              rules: [\n                {\n                  required: true,\n                  message: 'Please input download video URL!',\n                },\n              ],\n            },\n          ]"}]})],1),_c('a-form-item',{attrs:{"label":"Read Blog URL"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:(['read_blog']),expression:"['read_blog']"}]})],1),_c('a-form-item',{attrs:{"label":"Embed Video URL"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'embed_video',
            {
              rules: [
                {
                  required: true,
                  message: 'Please add embed_video video URL!',
                },
              ],
            },
          ]),expression:"[\n            'embed_video',\n            {\n              rules: [\n                {\n                  required: true,\n                  message: 'Please add embed_video video URL!',\n                },\n              ],\n            },\n          ]"}]})],1),_c('a-form-item',{attrs:{"label":"Description"}},[_c('wysiwyg',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'description',
            {
              rules: [
                {
                  required: true,
                  validator: (rule, value, callback) => _vm.validateInput(rule, value, callback, 'Please input description!'),
                },
              ],
            },
          ]),expression:"[\n            'description',\n            {\n              rules: [\n                {\n                  required: true,\n                  validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please input description!'),\n                },\n              ],\n            },\n          ]"}],model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_c('a-form-item',{attrs:{"wrapper-col":{ span: 20, offset: 4 }}},[(!_vm.empty(_vm.error))?_c('a-tag',{staticClass:"d-block p-1",attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('a-button',{attrs:{"type":"primary","html-type":"submit","loading":_vm.isLoading}},[_vm._v(_vm._s(_vm.isEdit ? 'Update Page' : 'Create Page'))])],1)],1)],1)],1):_c('div',[_c('h2',[_vm._v("Page not found")]),_c('a-button',{staticClass:"mb-3",attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push({ name: 'AdminPages' })}}},[_vm._v("Go to pages list")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }